import firebase from 'firebase/compat/app';
import { Config } from './config';

firebase.initializeApp(Config());

export { firebase };
